import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Template",
  "use": "icon-Template-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-Template\">\n\t<path d=\"M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM8.34,3.89H6.44v5H5.57v-5H3.66V3.15H8.34Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol